const keyboardDatePickerModalDocCompany = {
  label: 'Duracion'
};

export default keyboardDatePickerModalDocCompany;
